export function FilePreviewModal({ url, name, onClose }: { url: string; name: string; onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70" onClick={onClose}>
      <div
        className="bg-bg-panel border border-border rounded-xl w-full max-w-5xl mx-4 shadow-2xl animate-pop flex flex-col h-[85vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-border">
          <h2 className="text-sm font-semibold text-white truncate">{name}</h2>
          <div className="flex items-center gap-4 shrink-0">
            <a href={url} target="_blank" rel="noreferrer" className="text-xs text-accent hover:underline">
              Open in new tab
            </a>
            <button onClick={onClose} className="text-muted hover:text-white">✕</button>
          </div>
        </div>
        <iframe src={url} title={name} className="flex-1 w-full rounded-b-xl bg-[#ffffff]" />
      </div>
    </div>
  );
}
